var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkishFlagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C18 14.0304 17.7893 14.5391 17.4142 14.9142C17.0391 15.2893 16.5304 15.5 16 15.5H2C1.46957 15.5 0.960859 15.2893 0.585786 14.9142C0.210714 14.5391 0 14.0304 0 13.5V4.5C0 3.96957 0.210714 3.46086 0.585786 3.08579C0.960859 2.71071 1.46957 2.5 2 2.5H16C16.5304 2.5 17.0391 2.71071 17.4142 3.08579C17.7893 3.46086 18 3.96957 18 4.5V13.5Z",
    fill: "#E30917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 12C7.20434 12 6.44128 11.6839 5.87867 11.1213C5.31606 10.5587 4.99999 9.79564 4.99999 8.99999C4.99999 8.20434 5.31606 7.44128 5.87867 6.87867C6.44128 6.31606 7.20434 5.99999 7.99999 5.99999C8.65499 5.99999 9.25999 6.21249 9.75349 6.56899C9.40946 6.17755 8.9859 5.86399 8.51109 5.64922C8.03627 5.43444 7.52112 5.3234 6.99999 5.32349C6.02492 5.32349 5.08979 5.71083 4.40031 6.40031C3.71083 7.08979 3.32349 8.02492 3.32349 8.99999C3.32342 9.48283 3.41847 9.96096 3.6032 10.4071C3.78793 10.8532 4.05873 11.2585 4.40013 11.6C4.74153 11.9414 5.14685 12.2123 5.59294 12.3971C6.03902 12.5819 6.51714 12.677 6.99999 12.677C8.09749 12.677 9.07999 12.1935 9.75349 11.431C9.24382 11.8012 8.62994 12.0004 7.99999 12ZM9.95649 9.11499L11.1765 9.39599L11.2865 10.6425L11.9305 9.56949L13.1505 9.84999L12.3285 8.90599L12.972 7.83249L11.8205 8.32249L10.9985 7.37799L11.1085 8.62499L9.95649 9.11499Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkishFlagIcon);
export default __webpack_public_path__ + "static/media/turkish_flag-icon.c4f3386535734e6d4993f8c901cbe438.svg";
export { ForwardRef as ReactComponent };